import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import type { ReservationInReducer } from './slice'
import { fetchReservationInfoApi } from 'src/services/oms'
import {
  fetchAvailableDateApi,
  fetchReserveBrandInfoApi, fetchTimeslotApi
} from 'src/services/reserve'

export const fetchReservationInfoAction = createAsyncThunk(
  '@reservation/reservation-info',
  async (params, thunkApi) => {
    const state = thunkApi.getState() as ReservationInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id
    const result = await fetchReservationInfoApi({ menuId })

    return result.data
  }
)

export const fetchReserveBrandInfoAction = createAsyncThunk(
  '@reservation/reserve-outlet-config',
  async ({ shortenBrandName }: { shortenBrandName: string }, thunkApi) => {
    try {
      const result = await fetchReserveBrandInfoApi({ shortenBrandName })

      if (result.data) {
        return result.data
      }

      throw result
    } catch (err) {
      return thunkApi.rejectWithValue(err.response.data)
    }
  }
)

export const fetchAvailableDateAction = createAsyncThunk(
  '@reservation/blocked-date',
  async ({
    outletId,
    pax,
    month,
    iServer = false
  }: {
    outletId: string
    pax: number
    month: string
    iServer?: boolean
  }) => {
    const result = await fetchAvailableDateApi({
      outletId,
      pax,
      month,
      iServer
    })

    return result.data
  }
)

export const fetchTimeslotAction = createAsyncThunk(
  '@reservation/timeslot',
  async ({
    outletId,
    pax,
    date,
    iServer = false
  }: {
    outletId: string
    pax: number
    date: string
    iServer?: boolean
  }) => fetchTimeslotApi({
    outletId,
    pax,
    date,
    iServer
  })
)

export const setReservationInfoCache = createAction(
  '@reservation/setReservationInfoCache',
  (params) => {
    return {
      payload: params
    }
  }
)

export const setReserveBrandInfoCache = createAction(
  '@reservation/setReserveBrandInfoCache',
  (params) => {
    return {
      payload: params
    }
  }
)

export const setAvailableDateCache = createAction(
  '@reservation/setAvailableDateCache',
  (params) => {
    return {
      payload: params
    }
  }
)
